import axios from "../../axios-atis";

import * as actionTypes from "./actionTypes";
import * as messages from "./messages";
import { fetchCompanies } from "./company";

export const authStart = () => {
  return {
    type: actionTypes.AUTH_START
  };
};

export const authSuccess = (token, userId, resticted) => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    idToken: token,
    userId: userId,
    resticted: resticted
  };
};

export const authFail = error => {
  return {
    type: actionTypes.AUTH_FAIL,
    error: error
  };
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("expirationDate");
  localStorage.removeItem("userId");
  sessionStorage.removeItem("requestSorts");
  sessionStorage.removeItem("requestFilters");
  sessionStorage.clear();
  return {
    type: actionTypes.AUTH_LOGOUT
  };
};

export const checkAuthTimeout = expirationTime => {
  return dispatch => {
    console.log("checkAuthTimeout");
    setTimeout(() => {
      dispatch(refreshToken());
    }, expirationTime * 1000);
  };
};

const refreshToken = () => {
  return dispatch => {
    const url = process.env.REACT_APP_ATIS_AUTH_BASE_URL + "auth/refresh";

    axios({
      method: "post",
      url: `${url}`,
    }).then(response => {
        if (!response.data.expiresIn) {
          dispatch(logout());
        } else {
          const expirationDate = new Date(
            new Date().getTime() + (response.data.expiresIn - 5) * 1000
          );
          localStorage.setItem("token", response.data.token);

          localStorage.setItem("expirationDate", expirationDate);
          localStorage.setItem("userId", response.data.userId);
          dispatch(checkAuthTimeout(response.data.expiresIn));
        }
      })
      .catch(err => {
        dispatch(logout());
      });
  };
};

export const auth = (username, password) => {
  return dispatch => {
    dispatch(authStart());
    const authData = {
      username: username,
      password: password
    };
    let url = "/auth/login";
    
    axios({
      method: "post",
      url : url,
      baseURL: process.env.REACT_APP_ATIS_AUTH_BASE_URL,
      data: authData
    }).then(response => {
        const expirationDate = new Date(
          new Date().getTime() + (response.data.expiresIn - 5) * 1000
        );
        //console.log("token", response.data.token);
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("expirationDate", expirationDate);
        localStorage.setItem("userId", response.data.userId);
        dispatch(authSuccess(response.data.token, response.data.userId));
        dispatch(fetchUserCompany());
        dispatch(fetchCompanies());
        dispatch(checkAuthTimeout(response.data.expiresIn));
      })
      .catch(err => {
        if (err.response && err.response.data && err.response.data.error) {
          dispatch(authFail(err.response.data.error));
        } else {
          dispatch(authFail(messages.UNHAUTORIZED_MESG));
        }
      });
  };
};

export const setAuthRedirectPath = path => {
  return {
    type: actionTypes.SET_AUTH_REDIRECT_PATH,
    path: path
  };
};

export const authCheckState = () => {
  return dispatch => {
    const token = localStorage.getItem("token");
    if (!token) {
      dispatch(logout());
    } else {
      const expirationDate = new Date(localStorage.getItem("expirationDate"));
      dispatch(refreshToken());
      /*if (expirationDate <= new Date()) {
                dispatch(refreshToken());
            } else {*/
      const userId = localStorage.getItem("userId");
      const restricted = localStorage.getItem("restricted");
      dispatch(authSuccess(token, userId, restricted));
      dispatch(fetchUserCompany());
      dispatch(
        checkAuthTimeout(
          (expirationDate.getTime() - new Date().getTime()) / 1000
        )
      );
      // }
    }
  };
};

export const fetchUserCompanyBegin = () => ({
  type: actionTypes.FETCH_COMPANY_BEGIN
});

export const fetchUserCompanySuccess = company => {
  return {
    type: actionTypes.FETCH_COMPANY_SUCCESS,
    payload: { company }
  };
};

export const fetchUserCompanyError = error => {
  return {
    type: actionTypes.FETCH_COMPANY_FAILED,
    payload: { error }
  };
};
export const fetchUserCompany = () => {
  return dispatch => {
    dispatch(fetchUserCompanyBegin());

    let url = "/mycompany";
    axios
      .get(url)
      .then(response => {
        dispatch(fetchUserCompanySuccess(response.data));
      })
      .catch(err => {
        dispatch(fetchUserCompanyError(err));
      });
  };
};

export const updtUserCompanyBegin = () => ({
  type: actionTypes.UPDATE_COMPANY_BEGIN
});

export const updtUserCompanySuccess = company => {
  return {
    type: actionTypes.UPDATE_COMPANY_SUCCESS,
    payload: { company }
  };
};

export const updtUserCompanyError = error => {
  return {
    type: actionTypes.UPDATE_COMPANY_FAILED,
    payload: { error }
  };
};
export const updtUserCompany = company => {
  return dispatch => {
    dispatch(updtUserCompanyBegin());

    let url = "/company/" + company.id;
    axios
      .post(url, company)
      .then(response => {
        dispatch(updtUserCompanySuccess(response.data));
      })
      .catch(err => {
        dispatch(updtUserCompanyError(err));
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/auth.js